import store from '@/store'
export default {
  // 公司
  className: 'company',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '公司名称不可为空'
      ]
    },
    'address'
  ],
  search: [
    'name'
  ],
  action: {
    create: store.state.user && store.state.user.authority.company.create
      ? {} : false,
    edit: store.state.user && store.state.user.authority.company.edit ? {} : false,
    delete: store.state.user && store.state.user.authority.company.del ? {} : false
  }
}
